import { ComponentType } from 'react';
import { UsersList } from './users-list';

export const Users: ComponentType = () => {
  return <UsersList />;
};
